'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "disabled", "tooltipMessage", "trackingProperties", "appUsageTracker", "dashboard"];
import PropTypes from 'prop-types';
import ActionButton from '../ActionButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useEmailDashboardProblem from '../emailReport/useEmailDashboardProblem';
import { useTracker } from '../../utils/hooks/useTracker';
import { EVENTS } from '../../utils/usageTracker';
import { useUserRoleForDashboard } from '../../utils/trackingUtils';
import { getId as getDashboardId } from '../../data/schemas/dashboardSchema';
import { useRecurringShareAssets } from '../../data/hooks/useRecurringShareAssets';
import { DASHBOARD_OBJECT_TYPE } from 'dashboard-lib/public/emails/emails';
import { useShowDialog } from '../../dialog/ducks';
import { MANAGE_RECURRING_EMAILS_DIALOG } from '../../dialog/dialogTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const labelPropDefault = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reporting-action-components.actions.manageRecurringEmails.button.text"
});
const ManageRecurringDashboardEmailsButton = _ref => {
  let {
      label = labelPropDefault,
      disabled: isDisabledViaParentApp = false,
      tooltipMessage: appDefinedTooltip = '',
      trackingProperties,
      appUsageTracker,
      dashboard
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const dashboardId = getDashboardId(dashboard);
  const {
    data: recurringEmails
  } = useRecurringShareAssets({
    objectId: dashboardId,
    objectType: DASHBOARD_OBJECT_TYPE
  });
  const usageTracker = useTracker(appUsageTracker);
  const {
    problem,
    disabledMessage
  } = useEmailDashboardProblem({
    isManageExistingEmail: true,
    dashboard
  });
  const showDialog = useShowDialog();
  const userRole = useUserRoleForDashboard(dashboard);
  const handleClickManageRecurringEmailsButton = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickManageRecurringShareAsset, {
        object: 'email',
        actionType: 'edit',
        action: 'open',
        interactionSource: trackingProperties.interactionSource,
        assetType: 'dashboard',
        role: userRole
      });
    }
    showDialog({
      dialogType: MANAGE_RECURRING_EMAILS_DIALOG,
      dialogProps: {
        dashboard,
        appUsageTracker,
        assetSpecificTrackingProps: {
          role: userRole
        },
        objectId: dashboardId,
        objectType: DASHBOARD_OBJECT_TYPE
      }
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: recurringEmails && recurringEmails.length > 0 ? /*#__PURE__*/_jsx(ActionButton, Object.assign({
      label: label,
      disabled: isDisabledViaParentApp || !!problem,
      onClick: handleClickManageRecurringEmailsButton,
      tooltip: appDefinedTooltip || disabledMessage,
      dataTestId: 'dashboard-action-manage-recurring-emails'
    }, buttonProps)) : null
  });
};
ManageRecurringDashboardEmailsButton.propTypes = {
  label: PropTypes.element,
  disabled: PropTypes.bool,
  dashboard: PropTypes.object.isRequired,
  tooltipMessage: PropTypes.string,
  appUsageTracker: PropTypes.object.isRequired,
  trackingProperties: PropTypes.shape({
    interactionSource: PropTypes.string
  }).isRequired
};
export default ManageRecurringDashboardEmailsButton;